<template>
  <div class="home">
    <van-nav-bar
      placeholder
      fixed
      border
      left-arrow
      safe-area-inset-top
      title="余额"
      @click-left="onBackClick"
    />
   
    <div class="home-page-container">
     <div class="van-ellipsis blance-head">
          <div class="blance-count">{{ blance_count}}</div>
          <div class="blance-des">总资产(元)</div>
    </div>
      <van-tabs @click="handleToggleTab"  v-model="type">
        <van-tab title="支出" name="expenditure"></van-tab>
        <van-tab title="收入" name="income"></van-tab>
      </van-tabs>
      
      <div class="home-page-content-wrapper">
        <div class="pulldown-bswrapper" ref="bsWrapper">
          <div class="pulldown-scroller">
            <div class="pulldown-wrapper">
              <div v-show="beforePullDown">
                <span>下拉刷新</span>
              </div>
              <div v-show="!beforePullDown">
                <div v-show="isPullingDown">
                  <span>加载中...</span>
                </div>
                <div v-show="!isPullingDown">
                  <span>刷新成功</span>
                </div>
              </div>
            </div>
            <div class="list-wrapper tabbar-bottom-area pulldown-list">
              <Balance-list v-for="(item,index) in list"
                          :key="index"
                          :list="item"
                          :type="type"
                          @reload="fetchList" />
              <van-empty image="default" description="暂无数据" v-if="list.length === 0" />
            </div>
            <div class="pullup-tips" v-if="pagination.page > 1">
              <div v-if="!isPullUpLoad" class="before-trigger">
                <span class="pullup-txt">上拉刷新</span>
              </div>
              <div v-else class="after-trigger">
                <span class="pullup-txt">加载中...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core';
import PullDown from '@better-scroll/pull-down';
import PullUp from '@better-scroll/pull-up';
import moment from 'moment';
import { Toast } from 'vant';
import Balance from '@/apis/Balance';
// eslint-disable-next-line import/extensions
import BalanceList from '@/components/balance/BalanceList';

BScroll.use(PullDown);
BScroll.use(PullUp);

// eslint-disable-next-line no-unused-vars
const TIME_BOUNCE = 800;
// eslint-disable-next-line no-unused-vars
const REQUEST_TIME = 1000;
const THRESHOLD = 70;
const STOP = 56;
// eslint-disable-next-line no-unused-vars
const STEP = 0;

export default {
  name: 'Blance_List',
  components: {
    BalanceList,
  },
  mounted() {
    this.handleType();
    this.fetchList();
    this.$nextTick(() => {
      this.initScroll();
    });
  },
  data() {
    return {
      dateSelectShow: false,
      value1: 0,
      blance_count:"0.00",
      value2: 0,
     
      beforePullDown: true,
      isPullingDown: false,
      bscroll: undefined,
      isPullUpLoad: false,
      list: [],
      pagination: {
        page: 1,
        total: 0,
      },
      type: 'expenditure',
    
    };
  },
  methods: {
    handleType() {
      if (this.$route.query.type) {
        this.type = this.$route.query.type;
      }
    },
    handleToggleTab(val) {
      this.type = val;
      this.fetchList();
    },
    async onDateConfirm(value) {
      // this.currentDate = value;
      this.$store.commit('updateCurrentDate', value);
      this.dateSelectShow = false;
      const toast = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      await this.fetchList();
      toast.clear();
    },
    onBackClick() {
      this.$router.replace('/');
    },
    onCardClick(item) {
      console.log('Card click ---> ', item);
    },
    async fetchList() {
      const { page, limit } = this.pagination;
      const params = {
        page,
        type: this.type,
      };
   
      const res = await Balance.getBalanceList(params);
      
      if (Number(res.code) === 1) {
        this.pagination.total = res?.count || 0;
        if (page === 1) {
          this.list = res?.data.userBalance;
        } else {
          this.list.push(...res?.data.userBalance);
        }
      
        this.blance_count = (res?.data).balance;
      }
    },
    initScroll() {
      this.bscroll = new BScroll(this.$refs.bsWrapper, {
        pullUpLoad: true,
        scrollY: true,
        click: true,
        taps: true,
        pullDownRefresh: {
          threshold: THRESHOLD,
          stop: STOP,
        },
      });
      this.bscroll.on('pullingDown', this.pullingDownHandler);
      this.bscroll.on('pullingUp', this.pullingUpHandler);
    },
    async pullingDownHandler() {
      console.log('trigger pullDown');
      this.beforePullDown = false;
      this.isPullingDown = true;
      this.pagination.page = 1;
      // STEP += 1;

      await this.fetchList();

      this.isPullingDown = false;
      await this.finishPullDown();
    },
    async finishPullDown() {
      this.bscroll.finishPullDown();
      setTimeout(() => {
        this.beforePullDown = true;
        this.bscroll.refresh();
      }, TIME_BOUNCE + 100);
    },
    async pullingUpHandler() {
      this.isPullUpLoad = true;
      if (this.pagination.page * this.pagination.limit < this.pagination.total) {
        this.pagination.page += 1;
        await this.fetchList();
      }
      this.bscroll.finishPullUp();
      this.bscroll.refresh();
      this.isPullUpLoad = false;
    },

  },
};
</script>

<style lang="scss" scoped>

.tabbar-bottom-area {
    margin-bottom: 50px;
    padding-bottom:0px;
}
.home {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;

}

.pulldown-bswrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
 
  .pulldown-wrapper {
    position: absolute;
    width: 100%;
    padding: 1.42rem;
    box-sizing: border-box;
    transform: translateY(-100%) translateZ(0);
    text-align: center;
    color: #999;
  }

  .pullup-tips {
    color: #999;
    text-align: center;
    padding: 20px;
  }
}

.list-wrapper {

  box-sizing: border-box;
  flex-grow: 1;
  height: 100%;
  /*overflow: auto;*/
  background-color:#ffffff;
 
}

::v-deep .van-nav-bar__text {
  color: #fff;
}

.home-page-container {
  height: calc(100vh - 46px - 50px);
  display: flex;
  flex-direction: column;
  
}

.home-page-search {
  flex-shrink: 0;
}

.home-page-content-wrapper {
  flex-basis: 0;
  flex-grow: 1;
  position: relative;

  overflow-y: scroll;
}

.filter-bar-wrapper {
  height: 40px;
  margin-top: 4px;
  //background-color: #fff;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 1.5rem;
  font-family: Sans-serif;
  .filter-row {
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 600;
    .label {
      margin-right: 1rem;
    }
    .value {
      cursor: pointer;
    }
  }
}
.blance-head{
  background: #196c44;
  height:15rem;
  margin-bottom:0.5rem;
  .blance-count{
    margin-top:5rem;
    color: #ffffff;
    text-align: center;
    font-size:2.5rem
  }
  .blance-des{
    color: #ffffff;
    text-align: center;
    font-size:1rem;
    padding-top:0.5rem;
    
  }
}

</style>
<style>
 .van-hairline--bottom:after {
  border-bottom-width: 0px;
 }

.van-tabs__line{
  width: calc(100% / 3);
  background-color:rgb(26, 107, 69);
}
</style>
